<template>
  <omint-page-content>
    <div class="term-box">
      <template v-if="!autenticado">
        <OmtTypography as="h1-bold" mb="16px">Verificação de identidade</OmtTypography>
        <OmtTypography v-if="autorizador === 'BIO-UNICO'" as="h3-semi-bold" mb="24px">
          Não conseguimos validar sua biometria, para seguir com sua identificação enviaremos um código de verificação.
          <br />
          Selecione o e-mail para recebê-lo.
        </OmtTypography>
        <OmtTypography v-else as="h3-semi-bold" mb="24px">
          Para confirmar sua identidade enviaremos um código de verificação. Selecione o e-mail para recebê-lo.
        </OmtTypography>
      </template>

      <OmtTypography as="h1-bold" mb="16px" v-if="emails.length > 0">E-mail:</OmtTypography>
      <OmtRadioGroup
        v-if="emails.length > 0"
        hasDivider
        :values="emails.map(e => ({ id: e, label: e }))"
        :value.sync="emailSelecionado"
        customValueKey="id"
        mb="40px"
        ml="1px"
      />

      <CBox borderRadius="8px" backgroundColor="var(--colors-light-primary-light-gray)" p="16px" mb="24px">
        <CFlex>
          <CBox>
            <OmtIcons mr="16px" size="xl" name="lightbulb" />
          </CBox>
          <OmtTypography as="h1-bold" mb="16px">Atenção:</OmtTypography>
        </CFlex>
        <OmtTypography as="p1" v-if="emails.length === 0">
          <b>Não identificamos um e-mail cadastrado. </b>
          Entre em contato com a central de atendimento Omint para orientações: <b>0800 726 4000</b>.
        </OmtTypography>
        <OmtTypography as="p1" v-else>
          Caso você não tenha acesso à este email, entre em contato com a central de atendimento Omint para orientações:
          <b>0800 726 4000.</b>
        </OmtTypography>
      </CBox>
    </div>
    <OmtButton
      variant="solid"
      width="100%"
      height="50px"
      border="0.5px solid var(--colors-light-secondary-divider)"
      borderRadius="40px"
      data-cy="button-entrar"
      @click="handleClick()"
      :disabled="emails.length > 0 && !emailSelecionado"
      mb="3"
    >
      <OmtTypography as="h1-bold" color="white" v-if="autenticado"> Continuar </OmtTypography>
      <OmtTypography as="h1-bold" color="white" v-else-if="emails.length > 0"> Enviar código </OmtTypography>
      <OmtTypography as="h1-bold" color="white" v-else>Ligar para a central Omint</OmtTypography>
    </OmtButton>
  </omint-page-content>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default {
  name: "MailCheck",
  mounted() {
    if (!this.hash) {
      this.$router.replace({ name: "first-access.terms" });
      return;
    }
    this.$root.$emit("change-title-label", "Confirmação de Identidade");
  },
  data() {
    return {
      emailSelecionado: null
    };
  },
  computed: {
    ...mapState("firstAccess", ["autorizador", "autenticado", "emails", "hash"])
  },
  methods: {
    ...mapActions("firstAccess", ["sendCode"]),
    async handleClick() {
      if (this.emails.length === 0) {
        window.open("tel:08007264000", "_self");
        return;
      }
      if (this.emailSelecionado) {
        await this.$root.$emit("show-loading");
        const errorMessage = await this.sendCode({ email: this.emailSelecionado });
        await this.$root.$emit("hide-loading");
        if (errorMessage !== "") {
          Swal.fire({
            title: "Erro",
            text: errorMessage,
            confirmButtonText: "Ok",
            allowEscapeKey: false,
            allowOutsideClick: false
          });
          return;
        }
        if (this.autenticado) {
          this.$router.push({ name: "first-access.password" });
          return;
        }
        await Swal.fire({
          title: "Sucesso",
          text: `Token enviado para ${this.emailSelecionado}`,
          confirmButtonText: "OK",
          icon: "success"
        });
        this.$router.push({ name: "first-access.code", params: { email: this.emailSelecionado } });
      }
    }
  }
};
</script>

<style scoped>
.term-box {
  height: calc(100vh - 180px);
  overflow-y: auto;
}
</style>
